var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#spotify_svg__clip0_7824_5081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.997 4.8c-3.96 0-7.2 3.24-7.2 7.2s3.24 7.2 7.2 7.2 7.2-3.24 7.2-7.2-3.18-7.2-7.2-7.2zm3.3 10.38c-.12.24-.42.3-.6.12-1.68-1.02-3.84-1.26-6.36-.66-.24.06-.48-.12-.54-.3-.06-.24.12-.48.3-.54 2.76-.6 5.1-.36 6.96.78.3.12.36.42.24.6zm.9-1.98c-.18.24-.48.36-.78.18-1.92-1.2-4.92-1.56-7.14-.84-.3.06-.6-.06-.66-.36-.06-.3.06-.6.36-.66 2.64-.78 5.88-.42 8.1.96.18.12.3.48.12.72zm.06-1.98c-2.34-1.38-6.18-1.5-8.34-.84-.36.12-.72-.12-.84-.42-.12-.36.12-.72.42-.84 2.58-.78 6.78-.6 9.42.96.3.18.42.6.24.96-.18.24-.6.36-.9.18z",
    fill: "#0D0C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spotify_svg__clip0_7824_5081"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgSpotify;